import Separator, { SeparatorOrientation } from '../../atoms/separator/Separator';
import { ActivityCard, ActivityCardRootVariant } from './ActivityCard';
import React from 'react';
import { ActivityCardHeaderUserFactory } from './ActivityCardHeaderUserFactory';
import {
  ActivityMessagingPreview,
  ActivityMessagingPreviewProps,
} from '../activity-messaging/ActivityMessagingPreview.tsx';
import { ActivityMessagingType } from '../activity-messaging/ActivityMessagingPreview.types.ts';

export const ActivityCardFactory = React.forwardRef<
  React.ElementRef<'div'>,
  ActivityMessagingPreviewProps & {
    pinned?: boolean;
  }
>(({ pinned = false, ...props }, ref) => {
  return (
    <ActivityCard.Root
      ref={ref}
      variant={
        props.type === ActivityMessagingType.INTERKAB_SOLUTIONS
          ? ActivityCardRootVariant.INTERKAB
          : ActivityCardRootVariant.DEFAULT
      }
    >
      <ActivityCard.Header>
        <ActivityCardHeaderUserFactory type={props.type} />
        <ActivityCard.Header.Metadata>
          <ActivityCard.Header.Metadata.Date>
            {new Date().toLocaleDateString('fr-FR', {})}
          </ActivityCard.Header.Metadata.Date>

          <div className="flex items-center gap-2.5">
            {pinned ? <ActivityCard.Header.Metadata.Pinned /> : null}

            <Separator
              orientation={SeparatorOrientation.VERTICAL}
              className="h-3 self-center"
            />

            <ActivityCard.Header.Metadata.Dropdown open={false} />
          </div>
        </ActivityCard.Header.Metadata>
      </ActivityCard.Header>

      <ActivityCard.Content.ErrorBoundary>
        <ActivityMessagingPreview {...props} />
      </ActivityCard.Content.ErrorBoundary>
    </ActivityCard.Root>
  );
});

ActivityCardFactory.displayName = 'ActivityCardFactory';
